const HOME_CHALLENGE_LIMIT = 3;

function byPosition(a, b) {
  return (a.position ?? 0) - (b.position ?? 0);
}

export function selectHomeChallenges(tasks, limit = HOME_CHALLENGE_LIMIT) {
  const list = Array.isArray(tasks) ? tasks.filter(Boolean) : [];
  const open = list.filter((task) => !task.claimed);
  const claimed = list.filter((task) => task.claimed);

  let picked;
  if (claimed.length === 0) {
    picked = open.slice(0, limit);
  } else if (open.length === 0) {
    picked = claimed.slice(0, limit);
  } else if (open.length === 1) {
    picked = [...claimed.slice(0, Math.max(limit - 1, 0)), ...open].slice(0, limit);
  } else {
    picked = [claimed[0], ...open.slice(0, Math.max(limit - 1, 0))].slice(0, limit);
  }

  return picked.sort(byPosition);
}
